import { flowRight } from 'lodash/fp';
import { withProps } from 'recompose';
import ListTable from '../ListTable';
import listProvider from '../List/listProvider';

export default flowRight([
    withProps({ forcedMode: 'manager' }),
    listProvider,
])(ListTable);
